import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit, inject } from '@angular/core';
import { htmlUrls } from '@shared/utils/router-paths';
import { exhaustMap, finalize, switchMap, takeUntil, tap } from 'rxjs/operators';
import { EChallengeLevel } from './enum/challenge-level.enum';
import { SelectionStatusEnum } from './enum/selection-status.enum';
import { BaseComponent } from '@shared/components/base/base.component';
import { HeaderComponent, HeaderConfigModel } from '@shared/components/header/header.component';
import { ChallengeAchievementModel } from './models/challenge-achievement-model';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';
import { ChallengeAchievementService } from './services/challenge-achievement.service';
import { SnackBarTypes } from '@shared/components/cutome-snack-bar/custome-snack-bar.component';
import { SearchFilterModel } from '@shared/model/categoryAndSearch/search-filter-model';
import { ChallengeStatisticModel } from './models/challenge-statistic-model';
import { ChallengeStateEnum } from './enum/challenge-state.enum';
import { ActivatedRoute } from '@angular/router';
import { IChallengeItem } from './models/IChallengeItem.interface';
import { MatDialog } from '@angular/material/dialog';
import { PickChallengeDialogComponent } from '@shared/components/dialogs/pick-challenge-dialog/pick-challenge-dialog.component';
import { ChallengeConfig, ChallengeItemPipe } from '@shared/pipes/challenge-model-pipe/challenge-item.pipe';
import { CommonModule, Location } from '@angular/common';
import { Observable, of, Subject } from 'rxjs';
import { TServiceResult } from '@shared/helper/t-service-result';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { AchievementAggregatorService } from './services/achievement-aggregator.service';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '@shared/module/shared.module';
import { ChallengeItemComponent } from './components/challenge-item/challenge-item.component';
import { ensureSwiperRegistered } from '@shared/loaders/swiper-loader';

@Component({
  selector: 'app-challenges',
  templateUrl: './challenges.component.html',
  styleUrls: ['./challenges.component.scss'],
  host: { ngSkipHydration: 'true' },
  imports: [
    CommonModule,
    HeaderComponent,
    MatTabsModule,
    ChallengeItemComponent,
    SharedModule,
    MatExpansionModule,
    ChallengeItemPipe
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ChallengesComponent extends BaseComponent implements OnInit {
  private location = inject(Location);
  private _dialog = inject(MatDialog);

  private activatedRoute = inject(ActivatedRoute);
  private challengeService = inject(ChallengeAchievementService);
  private achievementAggregatorService = inject(AchievementAggregatorService);

  activeState = 1;
  private challengeClick$ = new Subject<IChallengeItem>();


  routes = htmlUrls;

  termFilterChallengeWithState: TermFilterModel = new TermFilterModel(0, 100);
  searchFilterPickedChallenges: SearchFilterModel = new SearchFilterModel();

  allChallenges!: ChallengeAchievementModel[];

  challengeLevels = EChallengeLevel;

  loadingChallenges!: boolean;
  joinLoadingMap: Record<string, boolean> = {};
  activeChallenges: ChallengeAchievementModel[] = [];
  completedChallenges: ChallengeAchievementModel[] = [];

  challengeStatistic: ChallengeStatisticModel = new ChallengeStatisticModel();
  selectionStatus = SelectionStatusEnum;
  isLoadingMyChallenge = true;

  headerConfig: HeaderConfigModel = {
    title: 'چالش‌ها',
    hasAction: false,
    actionList: []
  };

  mobileActiveChallenge: ChallengeConfig = {
    progressBar: true,
    feed: false,
    percent: true,

    profile: false,
    isClickable: true,
    stateVisibility: false,
    hasBackground: false,
    userChallenge: false,
  }

  desktopActiveChallenge: ChallengeConfig = {
    progressBar: true,
    feed: false,
    percent: true,

    profile: false,
    isClickable: true,
    stateVisibility: false,
    hasBackground: false,
    userChallenge: false,
  }


  allChallengeConfig: ChallengeConfig = {
    progressBar: false,
    feed: false,
    percent: false,

    profile: false,
    isClickable: true,
    stateVisibility: false,
    hasBackground: false,
    userChallenge: false,
  }

  // *-------------------------------------------------
  challengesWithLevel: IChallenge[] = [];

  allActivesSearchFilter: SearchFilterModel = new SearchFilterModel();

  constructor() {
    super();
    this.allActivesSearchFilter.pgNumber = 0;
    this.allActivesSearchFilter.pgSize = 100;
  }

  async ngOnInit() {

    await ensureSwiperRegistered();

    this.challengeClick$.pipe(
      exhaustMap(item => {
        return this.joinChallenge(item)
      })
    ).subscribe();


    this.activatedRoute.queryParams.pipe(
      switchMap(qParam => {
        if (qParam['allChallenges'])
          this.activeState = 2;
        return this.getAllChallengeAchievement();
      }),
      switchMap(allChallengesAchived => {
        if (!allChallengesAchived?.hasError) {
          // ? Create a map from level
          const levelMap = new Map<number, ChallengeAchievementModel[]>();

          // ? get level maps in array
          allChallengesAchived?.result?.items?.forEach(challenge => {
            if (levelMap.has(challenge.level!)) {
              levelMap.get(challenge.level!)?.push(challenge);
            } else {
              levelMap.set(challenge.level!, [challenge]);
            }
          });

          // ? convert Map to array
          const levelArrays: ChallengeAchievementModel[][] = Array.from(levelMap.values());
          levelArrays.forEach(level => {
            const levelToAssign: IChallenge = {
              items: level,
              title: level[0]?.levelLable!
            }
            this.challengesWithLevel.push(levelToAssign);
          });

          this.challengesWithLevel.sort((a, b) => {
            if (a.items[0]?.level! < b.items[0]?.level!) {
              return -1;
            } else if (a.items[0]?.level! > b.items[0]?.level!) {
              return 1;
            }
            return 0;
          });
        }
        const state: number[] = [ChallengeStateEnum.Started];
        return this.challengeService.getChallengesByFilter(this.searchFilterPickedChallenges, state, this.currentUser?.id!)
      }),
      switchMap(challengesList => {
        if (!challengesList?.hasError) {
          this.completedChallenges = challengesList?.result?.items.filter(x => (x.userChallenges![0]?.state === ChallengeStateEnum.Succeeded));

          // let sortedActiveChallenge: ChallengeAchievementModel = new ChallengeAchievementModel();
          // let sortedActiveChallenges: ChallengeAchievementModel[] = [];
          challengesList?.result?.items?.map(challenge => {
            return challenge.userChallenges?.sort((a, b) => {
              if (a.createdAt < b.createdAt) {
                return -1
              }
              else if (a.createdAt > b.createdAt) {
                return 1
              }
              return 0;
            });
          });

          challengesList?.result?.items?.forEach(ac => {
            ac.userChallenges?.forEach(x => {
              if (x.state === ChallengeStateEnum.Started) {
                this.activeChallenges.push(ac);
              }
            });
          });

          // this.activeChallenges = challengesList.result?.items.filter(x => x.userChallenges[0]?.state === ChallengeStateEnum.Started);
        }

        return this.challengeService.getMyChallengesStatistics()
      }),
      takeUntil(this.unsubscribe$)
    ).subscribe(res => {
      if (!res?.hasError) {
        this.challengeStatistic = res?.result;
        this.isLoadingMyChallenge = false;
      }
    });
  }

  compareByLevel(a: any, b: any) {
    if (a.level < b.level) {
      return -1;
    } else if (a.level > b.level) {
      return 1;
    }
    // a must be equal to b
    return 0;
  }

  activeTab(id: number) {
    this.activeState = id;
    if (this.activeState == 1)
      this.location.replaceState('/challenges');
    else
      this.location.replaceState('/challenges?allChallenges=true');
  }

  getAllChallengeAchievement(): Observable<TServiceResult<PageList<ChallengeAchievementModel>>> {
    this.loadingChallenges = true;
    return this.achievementAggregatorService.getActivesWithState(this.allActivesSearchFilter).pipe(
      tap(res => {
        if (!res?.hasError) {
          this.allChallenges = res?.result?.items;
          this.loadingChallenges = false;
        }
      })
    )
  }



  joinChallenge(item: IChallengeItem) {
    if (item.canJoin == this.selectionStatus.Allowed) {
      this.joinLoadingMap[item.id!] = true;
      return this.challengeService.pickChallengeWithDetail(item.id!).pipe(
        tap(res => {
          if (!res?.hasError) {
            item.canJoin = this.selectionStatus.CurrentlySelected;
            this._dialog.open(PickChallengeDialogComponent,
              {
                panelClass: 'pick-challenge-dialog',
                data: { challenge: res?.result }
              })
            this.activeChallenges.push(res?.result);
          }

          if (res?.error?.code === 409) {
            this.snackbarService.openSnackbar(SnackBarTypes.error, 'شما در چالش مشابه شرکت کرده‌اید.');
          }
        }),
        finalize(() => this.joinLoadingMap[item.id!] = false)
      )
    }
    if (item.canJoin == this.selectionStatus.NotAllowed) {
      this.snackbarService.openSnackbar(SnackBarTypes.error, 'شما در چالش مشابه شرکت کرده‌اید.');
      return of(null)
    }
    return of(null)
  }

  onjoinChallenge(item: IChallengeItem) {
    this.challengeClick$.next(item);
  }

  override ngOnDestroy(): void {
    this.challengeClick$.unsubscribe();
  }
}

interface IChallenge {
  title: string;
  items: ChallengeAchievementModel[];
}
